/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, OnInit } from '@angular/core';
import {
  faBars,
  faChevronDown,
  faChevronRight,
  faFolder,
  faForward,
  faPhotoVideo,
  faTasks,
  faTimes,
  faChartBar
} from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: false
})
export class HomeComponent implements OnInit {
  faChevronRight = faChevronRight;
  faChevronDown = faChevronDown;
  faTasks = faTasks;
  faFolder = faFolder;
  faPhotoVideo = faPhotoVideo;
  faTimes = faTimes;
  faBars = faBars;
  faForward = faForward;
  faChartBar = faChartBar;

  sideMenuExpand = true;
  showTimeTrackingDasboardMenuItem: boolean = true;

  constructor() {}

  ngOnInit(): void {
    const sideMenustatus = sessionStorage.getItem('sideMenuExpanded');
    if (sideMenustatus == null) {
      this.sideMenuExpand = true;
    } else {
      this.sideMenuExpand = JSON.parse(sideMenustatus);
    }
  }

  sideMenuToggled() {
    this.sideMenuExpand = !this.sideMenuExpand;
    sessionStorage.setItem('sideMenuExpanded', this.sideMenuExpand.toString());
  }
}
